import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ProductType, PageType } from '../../types/product.type';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SxImageAssetPickerComponent } from './imageAssetPicker.component';
import { AssetsService, SponsorAssetFile } from '../../../../infrastructure/services/assets.service';
import { MappingPaymentComponent } from 'app/private/paymentGateways/mapping/mapping.payment.component';
import { MappingPaymentAttribute } from 'app/infrastructure/model/classes/paymentGateway.class';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'sx-modal-text',
  templateUrl: './modal.text.component.html'
})
export class SxTextModalComponent implements OnInit {
  systemCode: string;
  businessCode: string;
  productCode: string;

  @Input() modal: any;
  @Input() parameters: string[];
  @Input() label: string;
  @Output() selectedChanged: EventEmitter<string> = new EventEmitter();

  _selected: any;
  // Pass JSON into the component; parse it for the modal
  @Input() set selected(value: string) {
    if (value) {
      this._selected = JSON.parse(value);
    }
  }

  constructor(private modalService: NgbModal, private aRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.systemCode = this.aRoute.snapshot.params.systemcode;
    this.businessCode = this.aRoute.snapshot.params.businesscode;
    this.productCode = this.aRoute.snapshot.params.productcode;
  }

  open() {
    const modal = this.modalService.open(this.modal, { backdrop: 'static' });

    const modalRef: any = modal.componentInstance;
    modalRef.aRoute = this.aRoute;
    modalRef.selected = this._selected;
    modalRef.setParameters(this.parameters);

    modal.result.then((result) => {
        this._selected = result;
        // Serialize the result into a JSON string for uniform use in the designer
        const stringifiedResult = JSON.stringify(result);
        this.selectedChanged.emit(stringifiedResult);
      }, (reason) => {
      });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/shared/modal.text.component.ts